import React from "react";

const BlankPage = () => <p>Blank</p>;

export default BlankPage;
